export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_AUTH_SUCCESS = 'SET_AUTH_SUCCESS';

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const CREATE_NEW_PASSWORD = 'CREATE_NEW_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
